import type { BannerAdType } from './AdType';
import type { BluestackPreference } from '../Preference';

export type BannerViewProperties = {
    type: BannerAdType;
    shouldLoadWhenReady: boolean;
    placementId: string;
    preference?: BluestackPreference;
    onAdLoaded?: Function;
    onAdFailedToLoad?: Function;
    onAdRefreshed?: Function;
    onAdFailedToRefresh?: Function;
    onAdClicked?: Function;
};
